import { Console } from "console";
import { CommonApiResponse } from "../Controllers/Types/ApiResponse";
import { ProfileResponse } from "../Controllers/Types/UserDataResponce";
import apiClient from "./apiClient";
import { baseURL } from "./ApiConstant";

export const userProfile = async (token: string): Promise<ProfileResponse> => {
  try {
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/user/profile`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': FULL_TOKEN
      },
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200, userId: data.data['userId'], userData: data.data['userData'], companyData: data.data['companyData'] };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }

  } catch (error) {
    throw error;
  }
};

export const updateProfileImageApi = async (userId: number, file: File): Promise<CommonApiResponse> => {
  try {
    const formData = new FormData();

    if (file) {
      formData.append('profile', file);
    }

    const response = await apiClient.postForm(`/api/user/profile-image/update/${userId}`, formData);

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data['message'] };
    } else {
      return { status: false, error: 'Login failed' };
    }

  } catch (error: any) {
    return { status: false, error: 'An error occurred. Please try again later.' };
  }
}

export const updateUserProfileApi = async (
  userId: number,
  first_name: string,
  last_name: string,
  phone: string,
  address_1: string,
  address_2: string,
  city: string,
  post_code: string
): Promise<CommonApiResponse> => {
  try {
    const credentials = {
      "first_name": first_name,
      "last_name": last_name,
      "phone": phone,
      "address_1": address_1,
      "address_2": address_2,
      "city": city,
      "post_code": post_code,
    };

    const response = await apiClient.put(`/api/user/update/${userId}`, credentials);

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data['message'] };
    } else {
      return { status: false, error: 'Login failed' };
    }

  } catch (error: any) {
    return { status: false, error: 'An error occurred. Please try again later.' };
  }
}

export const updateCompanyDetailForProfileApi = async (
  companyId: number,
  company_name: string,
  company_regno: string,
  company_email: string,
  company_phone: string,
  company_address: string,
  post_code: string,
  city: string
): Promise<CommonApiResponse> => {
  try {
    const credentials = {
      "company_name": company_name,
      "company_regno": company_regno,
      "company_email": company_email,
      "company_phone": company_phone,
      "company_address": company_address,
      "post_code": post_code,
      "city": city
    };

    console.log(credentials);

    const response = await apiClient.put(`/api/user/update-company-details/${companyId}`, credentials);

    console.log(response);

    if (response.status === 200 || response.status === 201) {
      return { status: true, massage: response.data };
    } else if (response.status === 422) {
      return { status: false, error: response.data['message'] };
    } else {
      return { status: false, error: 'Login failed' };
    }

  } catch (error: any) {
    return { status: false, error: 'An error occurred. Please try again later.' };
  }
}